import React, { forwardRef } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input, InputRef, Space } from 'antd';
import Button from 'components/Button';
import { FilterDropdownProps } from 'antd/es/table/interface';
import { ColumnProps } from 'antd/es/table';

interface TableSearchCustomDropdownProps extends FilterDropdownProps {
  columnName: string;
  dataIndex?: ColumnProps['dataIndex'];
  onSearch: (
    selectedKeys: string[],
    confirm: FilterDropdownProps['confirm'],
    dataIndex: ColumnProps['dataIndex'],
  ) => void;
  onReset: (clearFilters: FilterDropdownProps['clearFilters']) => void;
}

const TableSearchCustomDropdown = forwardRef(
  (
    {
      selectedKeys,
      setSelectedKeys,
      confirm,
      clearFilters,
      close,
      dataIndex,
      columnName,
      onSearch,
      onReset,
    }: TableSearchCustomDropdownProps,
    ref: React.LegacyRef<InputRef> | undefined,
  ) => {
    return (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={ref}
          placeholder={`Search ${columnName}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            onSearch?.(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              onSearch?.(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              onReset?.(clearFilters);
              onSearch?.([], confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button type="link" size="small" onClick={close}>
            Close
          </Button>
        </Space>
      </div>
    );
  },
);

TableSearchCustomDropdown.displayName = 'TableSearchCustomDropdown';

export default TableSearchCustomDropdown;
